var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39684 9.96409C8.30518 9.95492 8.19518 9.95492 8.09434 9.96409C5.91268 9.89075 4.18018 8.10325 4.18018 5.90325C4.18018 3.65742 5.99518 1.83325 8.25018 1.83325C10.496 1.83325 12.3202 3.65742 12.3202 5.90325C12.311 8.10325 10.5785 9.89075 8.39684 9.96409Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 3.66675C16.8208 3.66675 18.2508 5.10591 18.2508 6.87508C18.2508 8.60758 16.8758 10.0192 15.1617 10.0834C15.0883 10.0742 15.0058 10.0742 14.9233 10.0834",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81316 13.3467C1.59483 14.8317 1.59483 17.2517 3.81316 18.7276C6.334 20.4142 10.4682 20.4142 12.989 18.7276C15.2073 17.2426 15.2073 14.8226 12.989 13.3467C10.4773 11.6692 6.34316 11.6692 3.81316 13.3467Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 18.3333C17.4715 18.1958 18.0949 17.9299 18.6082 17.5358C20.0382 16.4633 20.0382 14.6941 18.6082 13.6216C18.104 13.2366 17.4899 12.9799 16.839 12.8333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub);
export default __webpack_public_path__ + "static/media/sub.7202105c3ca4e71b0d6f3e3269402775.svg";
export { ForwardRef as ReactComponent };